const comparePartPosition = (a, b) => {
  const aPos = a ?? '';
  const bPos = b ?? '';
  if (!aPos && !bPos) return 0;
  if (!aPos) return 1;
  if (!bPos) return -1;

  const aParts = String(aPos).split('.').map(Number);
  const bParts = String(bPos).split('.').map(Number);
  const length = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < length; i += 1) {
    const diff = (aParts[i] ?? 0) - (bParts[i] ?? 0);
    if (diff !== 0) return diff;
  }

  return 0;
};

export default comparePartPosition;
